import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Alert,
  UncontrolledTooltip,
  Collapse,
  Accordion,
  AccordionItem,
  AccordionBody,
} from "reactstrap"
import {
  getKeycloakUsers,
  searchAdminUserByName,
} from "helpers/backend_helper"
import {
  addUsersToGroup,
  createNewUser,
  removeUsersFromGroup,
} from "helpers/keycloak_api_helper"
import KeycloakUserDrawer from "./KeycloakUserDrawer"
import {
  defaultPageSizeOptions,
  showToast,
  stringSorter,
  downloadExcel,
  checkboxFormatter,
  dateSorter,
  dateFormatter,
  booleanSorter,
} from "utils/general"
import TagsTree from "components/DropdownList/TagsTree"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import jsPDF from "jspdf"
import "jspdf-autotable"
import {
  Table as AntdTable,
  Switch,
  Form as AntdForm,
  Input as AntdInput,
  Select,
} from "antd"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import { tableDefaultHeight } from "constants/layout"
import moment from "moment"
import SelectKeycloakGroup from "components/DropdownList/SelectKeycloakGroup"
const { Search } = AntdInput

const KeycloakUsers = props => {
  const [groups, setGroups] = useState([])
  const [groupObjects, setGroupObjects] = useState([])
  const [users, setUsers] = useState([])
  const [filteredUsers, setFilteredUsers] = useState([])
  const [addModal, setAddModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showDrawer, setShowDrawer] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [ongoingAdd, setOngoingAdd] = useState(false)

  const [filtersOpen, setFiltersOpen] = useState("")
  const [groupHostFilter, setGroupHostFilter] = useState()
  const [appointmentsFilter, setAppointmentsFilter] = useState()
  const [groupMessagesFilter, setGroupMessagesFilter] = useState()
  const [videoSystemFilter, setVideoSystemFilter] = useState()
  const [videoSettingsFilter, setVideoSettingsFilter] = useState()

  const [fetchUsersGroups, setFetchUsersGroups] = useState(false)
  const [listAllUsers, setListAllUsers] = useState(false)
  const [showAdditionalColumns, setShowAdditionalColumns] = useState(false)
  const [singleGroup, setSingleGroup] = useState(true)

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [menu, setMenu] = useState(false) //Dropdown button state
  const [selectedTags, setSelectedTags] = useState([])

  const [userSearch, setUserSearch] = useState("")
  const [searchTriggers, setSearchTriggers] = useState(0) // Delayed search
  const [groupSearch, setGroupSearch] = useState(true)

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = props.t("User accounts") + " | Suvanto Care"
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Search or filter changed
  useEffect(() => {
    handleSearch()
  }, [searchText, users, groupHostFilter,
    appointmentsFilter, groupMessagesFilter, videoSettingsFilter, videoSystemFilter])

  useEffect(() => {
    if (searchTriggers > 0) {
      searchUser()
    }
  }, [searchTriggers])

  useEffect(() => {
    setUsers([])
    //setSelectedRowKeys([])
    setSingleGroup(false)
    if (groups?.length != 1) {
      setListAllUsers(false)
    }
  }, [groups])

  // Handle search function
  const handleSearch = () => {
    let searchTextLowercase = searchText.toLowerCase()
    let result = users.filter(
      data =>
        (data.username?.toLowerCase().includes(searchTextLowercase) ||
          data.description?.toLowerCase().includes(searchTextLowercase) ||
          data.groups?.toLowerCase().includes(searchTextLowercase.toLowerCase()) ||
          data.gsm?.toLowerCase().includes(searchTextLowercase) ||
          data.email?.toLowerCase().includes(searchTextLowercase) ||
          data.fullName?.toLowerCase().includes(searchTextLowercase)) &&
        (!groupHostFilter ||
          (groupHostFilter === "1" && data.groupHost) ||
          (groupHostFilter === "2" && !data.groupHost)) &&
        (!appointmentsFilter ||
          (appointmentsFilter === "1" && data.appointments) ||
          (appointmentsFilter === "2" && !data.appointments)) &&
        (!groupMessagesFilter ||
          (groupMessagesFilter === "1" && data.groupMessages) ||
          (groupMessagesFilter === "2" && !data.groupMessages)) &&
        (!videoSystemFilter ||
          (videoSystemFilter === "1" && data.videoContent) ||
          (videoSystemFilter === "2" && !data.videoContent)) &&
        (!videoSettingsFilter ||
          (videoSettingsFilter === "1" && data.videoAppSettings) ||
          (videoSettingsFilter === "2" && !data.videoAppSettings))
    )
    setFilteredUsers(result)
  }

  // Get users for table
  const fetchUsers = () => {
    if (!loading) {
      setLoading(true)
      setUsers([])
      //setSelectedRowKeys([])
      setSingleGroup(groups?.length == 1)
      setShowAdditionalColumns(groups.length == 0 ? false : fetchUsersGroups)
      if (groups?.length == 0) setFetchUsersGroups(false)
      setUserSearch("")
      setGroupSearch(true)

      getKeycloakUsers(abortRef.current, groups, fetchUsersGroups, listAllUsers)
        .then(result => {
          if (result.entries) {
            result.entries.sort((a, b) => (a.username > b.username ? 1 : -1))
            for (const user of result.entries) {
              let first = user.firstName ?? ""
              let last = user.lastName ?? ""
              user.fullName = (first + " " + last).trim()
              if (user.attributes) {
                user.description = user.attributes.description
                  ? user.attributes.description[0]
                  : ""
                user.gsm = user.attributes.gsm ? user.attributes.gsm[0] : ""
                user.videoRoomId = user.attributes.videoRoomId
                  ? user.attributes.videoRoomId[0]
                  : ""
                user.lastLogin = user.attributes.lastLogin
                  ? moment(user.attributes.lastLogin[0]).valueOf()
                  : 0
              }
              user.videoAppSettings = user.permissions?.videoAppSettings ?? false
              user.groupMessages = user.permissions?.groupMessages ?? false
              user.appointments = user.permissions?.appointments ?? false
              user.videoContent = user.permissions?.videoContent ?? false

              // Role
              switch (user.role) {
                case "admin": user.roleString = props.t("UserRoles.Organisation Admin"); break;
                case "private": user.roleString = props.t("UserRoles.Private User"); break;
                case "professional": user.roleString = props.t("Professional"); break;
                case "alarm_center": user.roleString = props.t("Alarm center"); break;
                default: user.roleString = null; break;
              }
            }
            setUsers(result.entries)
          } else {
            setUsers([])
          }
        })
        .catch(err => {
          console.log(err)
          setUsers([])
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  // Link users to a group
  const linkUsers = () => {
    if (!loading && groupObjects?.length == 1) {
      setLoading(true)
      addUsersToGroup(abortRef.current, groupObjects[0].label, selectedRowKeys)
        .then(result => {
          if (result == "OK") {
            fetchUsers()
            showToast(props.t("Success"), "success", 3000)
          } else {
            showToast(props.t("Error"), "error")
          }
        })
        .catch(err => {
          console.log(err)
          showToast(props.t("Error"), "error")
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  // Unlink users from a group
  const unlinkUsers = () => {
    if (!loading && groupObjects?.length == 1) {
      setLoading(true)
      //console.log("Unlink keys: ", selectedRowKeys)
      removeUsersFromGroup(abortRef.current, groupObjects[0].label, selectedRowKeys)
        .then(result => {
          if (result == "OK") {
            fetchUsers()
            showToast(props.t("Success"), "success", 3000)
          } else {
            showToast(props.t("Error"), "error")
          }
        })
        .catch(err => {
          console.log(err)
          showToast(props.t("Error"), "error")
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  // Search user by username
  const searchUser = () => {
    if (!loading) {
      setUsers([])
      setGroups([])
      setGroupObjects([])
      setShowAdditionalColumns(fetchUsersGroups)
      setSingleGroup(false)
      setListAllUsers(false)
      setGroupSearch(false)

      if (userSearch) {
        setLoading(true)
        searchAdminUserByName(abortRef.current, userSearch, false, fetchUsersGroups)
          .then(result => {
            if (result.entries?.length > 0) {
              for (const user of result.entries) {
                let first = user.firstName ?? ""
                let last = user.lastName ?? ""
                user.fullName = (first + " " + last).trim()
                if (user.attributes) {
                  user.description = user.attributes.description
                    ? user.attributes.description[0]
                    : ""
                  user.gsm = user.attributes.gsm ? user.attributes.gsm[0] : ""
                  user.videoRoomId = user.attributes.videoRoomId
                    ? user.attributes.videoRoomId[0]
                    : ""
                  user.lastLogin = user.attributes.lastLogin
                    ? moment(user.attributes.lastLogin[0]).valueOf()
                    : 0
                }
                user.videoAppSettings = user.permissions?.videoAppSettings ?? false
                user.groupMessages = user.permissions?.groupMessages ?? false
                user.appointments = user.permissions?.appointments ?? false
                user.videoContent = user.permissions?.videoContent ?? false

                // Role
                switch (user.role) {
                  case "admin": user.roleString = props.t("UserRoles.Organisation Admin"); break;
                  case "private": user.roleString = props.t("UserRoles.Private User"); break;
                  case "professional": user.roleString = props.t("Professional"); break;
                  case "alarm_center": user.roleString = props.t("Alarm center"); break;
                  default: user.roleString = null; break;
                }
              }
              setUsers(result.entries)
            } else {
              showToast(props.t("User not found"), "info", 3000, "toast-bottom-center")
            }
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error", 2000)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    }
  }

  // Reset selections
  const resetSelections = () => {
    setSelectedRowKeys([])
  }

  // Create user validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .matches(
          /^[a-z0-9]+[a-z0-9-]*[a-z0-9]+[.][a-z0-9]+[a-z0-9-]*[a-z0-9]$/,
          props.t("Invalid format")
        )
        .trim()
        .min(7, props.t("Too short"))
        .required(props.t("Required field")),
    }),
    onSubmit: values => {
      console.log("Submit: ", values)
      if (values.username && groupObjects?.length == 1) {
        setOngoingAdd(true)
        createNewUser(abortRef.current, values.username.toLowerCase(), groupObjects[0].label)
          .then(result => {
            if (result == "OK") {
              showToast(props.t("Created"), "success")
              setAddModal(false)
              validation.resetForm()
              fetchUsers()
            } else {
              showToast(props.t("Error"), "error")
            }
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error")
          })
          .finally(() => {
            setOngoingAdd(false)
          })
      }
    },
  })

  // Table structure
  const columns = [
    {
      title: props.t("Actions"),
      dataIndex: "actions",
      align: "center",
      render: editFormatter,
      fixed: "left",
      width: "100px",
      ellipsis: true,
    },
    ...(singleGroup
      ? [
        {
          title: props.t("Linked"),
          dataIndex: "linked",
          defaultSortOrder: "descend",
          sorter: (a, b) => a.linked - b.linked,
          align: "center",
          render: checkboxFormatter,
          width: "100px",
          ellipsis: true,
        },
      ]
      : []),
    {
      title: props.t("Username"),
      dataIndex: "username",
      render: usernameFormatter,
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "username", sortOrder)
      },
      fixed: "left",
      width: "200px",
      ellipsis: true,
    },
    ...(showAdditionalColumns
      ? [
        {
          title: props.t("Role"),
          dataIndex: "roleString",
          sorter: (a, b, sortOrder) => {
            return stringSorter(a, b, "roleString", sortOrder)
          },
          align: "center",
          width: "150px",
          ellipsis: true,
        },
      ]
      : []),
    {
      title: props.t("Email"),
      dataIndex: "email",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "email", sortOrder)
      },
      render: emailFormatter,
      width: "250px",
      ellipsis: true,
    },
    {
      title: props.t("Email verified"),
      dataIndex: "emailVerified",
      align: "center",
      render: cell => {
        return cell ? (
          <i className="mdi mdi-check-bold text-primary" />
        ) : (
          <i className="mdi mdi-close-thick text-danger" />
        )
      },
      sorter: (a, b, sortOrder) => {
        return booleanSorter(a, b, "emailVerified", sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      title: props.t("Name"),
      dataIndex: "fullName",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "fullName", sortOrder)
      },
      width: "200px",
      ellipsis: true,
    },
    {
      title: props.t("Description"),
      dataIndex: "description",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "description", sortOrder)
      },
      width: "200px",
      ellipsis: true,
    },
    {
      title: props.t("GSM"),
      dataIndex: "gsm",
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "gsm", sortOrder)
      },
      width: "150px",
      ellipsis: true,
    },
    {
      title: props.t("Created"),
      dataIndex: "createdTimestamp",
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["createdTimestamp"], b["createdTimestamp"], sortOrder)
      },
      render: dateFormatter,
      width: "190px",
      ellipsis: true,
    },
    {
      title: props.t("Last login"),
      dataIndex: "lastLogin",
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["lastLogin"], b["lastLogin"], sortOrder)
      },
      render: dateFormatter,
      width: "190px",
      ellipsis: true,
    },
    {
      title: props.t("Enabled"),
      dataIndex: "enabled",
      align: "center",
      render: cell => {
        return cell ? (
          <i className="mdi mdi-check-bold text-primary" />
        ) : (
          <i className="mdi mdi-close-thick text-danger" />
        )
      },
      sorter: (a, b, sortOrder) => {
        return booleanSorter(a, b, "enabled", sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    ...(showAdditionalColumns
      ? [
        {
          title: props.t("User management"),
          dataIndex: "adminManager",
          align: "center",
          render: cell => {
            return cell ? (
              <i className="mdi mdi-check-bold text-primary" />
            ) : <></>
          },
          sorter: (a, b, sortOrder) => {
            return booleanSorter(a, b, "adminManager", sortOrder)
          },
          width: "150px",
          ellipsis: true,
        },
        {
          title: props.t("Appointments"),
          dataIndex: "appointments",
          align: "center",
          render: cell => {
            return cell ? (
              <i className="mdi mdi-check-bold text-primary" />
            ) : <></>
          },
          sorter: (a, b, sortOrder) => {
            return booleanSorter(a, b, "appointments", sortOrder)
          },
          width: "150px",
          ellipsis: true,
        },
        {
          title: props.t("Group messages"),
          dataIndex: "groupMessages",
          align: "center",
          render: cell => {
            return cell ? (
              <i className="mdi mdi-check-bold text-primary" />
            ) : <></>
          },
          sorter: (a, b, sortOrder) => {
            return booleanSorter(a, b, "groupMessages", sortOrder)
          },
          width: "150px",
          ellipsis: true,
        },
        {
          title: props.t("Video system"),
          dataIndex: "videoContent",
          align: "center",
          render: cell => {
            return cell ? (
              <i className="mdi mdi-check-bold text-primary" />
            ) : <></>
          },
          sorter: (a, b, sortOrder) => {
            return booleanSorter(a, b, "videoContent", sortOrder)
          },
          width: "150px",
          ellipsis: true,
        },
        {
          title: props.t("Video app settings"),
          dataIndex: "videoAppSettings",
          align: "center",
          render: cell => {
            return cell ? (
              <i className="mdi mdi-check-bold text-primary" />
            ) : <></>
          },
          sorter: (a, b, sortOrder) => {
            return booleanSorter(a, b, "videoAppSettings", sortOrder)
          },
          width: "150px",
          ellipsis: true,
        },
        {
          title: props.t("Groups"),
          dataIndex: "groups",
          sorter: (a, b, sortOrder) => {
            return stringSorter(a, b, "groups", sortOrder)
          },
          width: "180px",
          ellipsis: true,
        },
      ]
      : []),
  ]

  function editFormatter(cell, row) {
    return (
      <>
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => {
            setShowDrawer(true)
            setSelectedRow(row)
          }}
        >
          <i className="mdi mdi-pencil" />
        </Button>
      </>
    )
  }

  function usernameFormatter(cell, row) {
    return (
      <>
        <span className={classnames({ "text-danger": !row.enabled })}>
          {row.username}
        </span>
        {!row.enabled && (
          <span className="ms-2 badge bg-danger font-size-12">
            {props.t("Disabled")}
          </span>
        )}
        {row.videoRoomId && !!row.groupHost && (
          <i className="ms-2 mdi mdi-account-voice text-primary" />
        )}
      </>
    )
  }

  function emailFormatter(cell, row) {
    return (
      <>
        {!row.emailVerified && !!cell && (
          <i className="me-1 mdi mdi-alert-circle text-danger" />
        )}
        <span>{cell}</span>
      </>
    )
  }

  const rowSelection = {
    selectedRowKeys,
    onSelect: (row, isSelect, rowArray) => {
      if (isSelect) {
        setSelectedRowKeys(prevState => [...prevState, row.id])
      } else {
        setSelectedRowKeys(prevState =>
          prevState.filter(prevItem => prevItem !== row.id)
        )
      }
    },
    onSelectAll: (isSelect, object, rowArray) => {
      if (isSelect) {
        rowArray.map(row =>
          setSelectedRowKeys(prevState => [...prevState, row.id])
        )
      } else {
        setSelectedRowKeys([])
      }
    },
  }

  // Export PDF table
  const exportPDF = () => {
    let message = props.t("PDF file exported succesfully!")
    const unit = "pt"
    const size = "A4" // Use A1, A2, A3 or A4
    const orientation = "landscape" // portrait or landscape
    const theme = "grid" //striped,  plain

    const marginLeft = 40
    const doc = new jsPDF(orientation, unit, size, theme)

    doc.setFontSize(14)

    let data = filteredUsers.map(elt => [
      elt.username,
      elt.fullName,
      //elt.basicUser ? props.t("Yes") : props.t("No"),
      elt.roleString,
      elt.groups,
      elt.email,
      elt.emailVerified ? props.t("Yes") : props.t("No"),
      elt.gsm,
      elt.enabled ? props.t("Yes") : props.t("No"),
      dateFormatter(elt.createdTimestamp),
      dateFormatter(elt.lastLogin),
    ])

    let content = {
      startY: 50,
      head: [
        [
          props.t("Username"),
          props.t("Name"),
          //props.t("Professional"),
          props.t("Role"),
          props.t("Groups"),
          props.t("Email"),
          props.t("Email verified"),
          props.t("GSM"),
          props.t("Enabled"),
          props.t("Created"),
          props.t("Last login"),
        ],
      ],
      body: data,
      styles: { overflow: "linebreak" },
      columnStyles: {
        4: { cellWidth: 60 },
      },
    }

    // Different export if user groups not fetched
    if (!showAdditionalColumns) {
      data = filteredUsers.map(elt => [
        elt.username,
        elt.fullName,
        elt.email,
        elt.emailVerified ? props.t("Yes") : props.t("No"),
        elt.gsm,
        elt.enabled ? props.t("Yes") : props.t("No"),
        dateFormatter(elt.createdTimestamp),
        dateFormatter(elt.lastLogin),
      ])

      content = {
        startY: 50,
        head: [
          [
            props.t("Username"),
            props.t("Name"),
            props.t("Email"),
            props.t("Email verified"),
            props.t("GSM"),
            props.t("Enabled"),
            props.t("Created"),
            props.t("Last login"),
          ],
        ],
        body: data,
      }
    }

    doc.text(props.t("User accounts"), marginLeft, 40)
    doc.autoTable(content)
    doc.save(props.t("User accounts") + " (" + new Date() + ")" + ".pdf")

    //Show toast
    showToast(message, "success")
  }

  // Creating Excel workbook+worksheet+download
  const generateExcel = () => {
    let heading = [
      [
        props.t("Username"),
        props.t("Name"),
        //props.t("Professional"),
        props.t("Role"),
        props.t("Groups"),
        props.t("Email"),
        props.t("Email verified"),
        props.t("GSM"),
        props.t("Enabled"),
        props.t("Created"),
        props.t("Last login"),
        props.t("User management"),
        props.t("Appointments"),
        props.t("Group messages"),
        props.t("Video system"),
        props.t("Video app settings"),
      ],
    ]
    let data = filteredUsers.map(elt => [
      elt.username,
      elt.fullName,
      //elt.basicUser,
      elt.roleString,
      elt.groups,
      elt.email,
      elt.emailVerified,
      elt.gsm,
      elt.enabled,
      dateFormatter(elt.createdTimestamp),
      dateFormatter(elt.lastLogin),
      elt.adminManager,
      elt.appointments,
      elt.groupMessages,
      elt.videoContent,
      elt.videoAppSettings
    ])

    // Different export if user groups not fetched
    if (!showAdditionalColumns) {
      heading = [
        [
          props.t("Username"),
          props.t("Name"),
          props.t("Email"),
          props.t("Email verified"),
          props.t("GSM"),
          props.t("Enabled"),
          props.t("Created"),
          props.t("Last login"),
        ],
      ]

      data = filteredUsers.map(elt => [
        elt.username,
        elt.fullName,
        elt.email,
        elt.emailVerified,
        elt.gsm,
        elt.enabled,
        dateFormatter(elt.createdTimestamp),
        dateFormatter(elt.lastLogin),
      ])
    }

    downloadExcel(props.t("User accounts"), heading, data)
    showToast(props.t("Excel file exported succesfully!"), "success")
  }

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={props.t("User accounts")} />
          <Row>
            <Col className="mb-3" style={{ maxWidth: "300px" }}>
              <Search
                placeholder={props.t("Username")}
                allowClear
                disabled={loading}
                value={userSearch}
                enterButton={props.t("Search")}
                onChange={event => {
                  setUserSearch(event.target.value)
                }}
                onSearch={v => {
                  setSearchTriggers(prevValue => prevValue + 1)
                }}
                style={{ minWidth: "200px" }}
              />
            </Col>
            <Col
              className="mb-3"
              style={{ minWidth: "200px", maxWidth: "400px" }}
            >
              <div className="d-inline-block" style={{ width: "100%" }}>
                <TagsTree
                  loadData={true}
                  expanded={true}
                  selectionChanged={setSelectedTags}
                />
              </div>
            </Col>
            <Col
              className="mb-3"
              style={{ minWidth: "200px", maxWidth: "400px" }}
            >
              <SelectKeycloakGroup
                disabled={loading}
                selection={groups}
                onChange={setGroups}
                onChangeObject={setGroupObjects}
                multiple={true}
                selectedTags={selectedTags}
              />
            </Col>
            <Col className="col-auto">
              <Button
                disabled={loading}
                color="primary"
                style={{
                  minWidth: "80px",
                  height: "32px",
                  padding: "inherit",
                }}
                onClick={() => {
                  fetchUsers()
                }}
              >
                {props.t("Search")}
              </Button>
            </Col>
          </Row>

          <Row className="mb-3 mt-1">
            <Col className="col-auto">
              <Label>
                <Switch
                  className="me-2"
                  checked={fetchUsersGroups}
                  disabled={loading}
                  onChange={v => {
                    setFetchUsersGroups(v)
                  }}
                  checkedChildren={
                    <div
                      className="d-flex"
                      style={{ alignItems: "center" }}
                    >
                      <i
                        className="bx bx-lock-open font-size-18"
                        style={{ marginTop: "2px" }}
                      />
                    </div>
                  }
                  unCheckedChildren={
                    <div
                      className="d-flex"
                      style={{ alignItems: "center" }}
                    >
                      <i
                        className="bx bx-lock-open font-size-18"
                        style={{ marginTop: "2px" }}
                      />
                    </div>
                  }
                />
                {props.t("Get groups and permissions")}
              </Label>
            </Col>
            {groups?.length == 1 &&
              <Col>
                <Label>
                  <Switch
                    className="me-2"
                    checked={listAllUsers}
                    disabled={loading || groups?.length > 1}
                    onChange={v => {
                      setListAllUsers(v)
                    }}
                    checkedChildren={
                      <div
                        className="d-flex"
                        style={{ alignItems: "center" }}
                      >
                        <i
                          className="bx bx-group font-size-18"
                          style={{ marginTop: "2px" }}
                        />
                      </div>
                    }
                    unCheckedChildren={
                      <div
                        className="d-flex"
                        style={{ alignItems: "center" }}
                      >
                        <i
                          className="bx bx-group font-size-18"
                          style={{ marginTop: "2px" }}
                        />
                      </div>
                    }
                  />
                  {props.t("List all users")}
                </Label>
              </Col>
            }
          </Row>

          <Card>
            <CardBody>
              <Row>
                <Col className="mb-3" style={{ maxWidth: "320px" }}>
                  <Search
                    placeholder={props.t("Search table")}
                    allowClear
                    value={searchText}
                    onChange={event => {
                      setSearchText(event.target.value)
                    }}
                    style={{ minWidth: "240px" }}
                  />
                </Col>
                <Col className="col-auto">
                  <Button
                    className="compact-button"
                    id="filter-button"
                    color="primary"
                    outline
                    onClick={() => {
                      filtersOpen.length > 0
                        ? setFiltersOpen("")
                        : setFiltersOpen("1")
                    }}
                  >
                    <UncontrolledTooltip
                      placement="bottom"
                      target="filter-button"
                    >
                      {props.t("Filters")}
                    </UncontrolledTooltip>
                    {filtersOpen ? (
                      <i className="mdi mdi-filter-minus"></i>
                    ) : (
                      <i className="mdi mdi-filter-menu"></i>
                    )}
                  </Button>
                </Col>
                {singleGroup &&
                  <Col className="col-auto">
                    <Button
                      className="compact-button"
                      color="success"
                      disabled={loading}
                      onClick={() => {
                        setAddModal(true)
                      }}
                    >
                      <i className="fas fa-user-plus"></i>
                      <span className="d-none d-lg-inline-block ms-2">
                        {props.t("Create a new user")}
                      </span>
                    </Button>
                  </Col>
                }

                <Col>
                  <span className="float-end ms-2">
                    <UncontrolledTooltip
                      placement="bottom"
                      target="downloadstatstable"
                    >
                      {props.t("Download statistics")}
                    </UncontrolledTooltip>
                    <Dropdown
                      id="printButtonServicesStats"
                      isOpen={menu}
                      toggle={() => setMenu(!menu)}
                      className="download-btn text-center"
                      type="button"
                      disabled={filteredUsers?.length == 0}
                    >
                      <DropdownToggle
                        id="downloadstatstable"
                        className="text-muted"
                        tag="i"
                      >
                        <i className="mdi mdi-download" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => generateExcel()}>
                          {props.t("Download .xlsx")}
                        </DropdownItem>
                        <DropdownItem onClick={() => exportPDF()}>
                          {props.t("Download .pdf")}
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </span>
                  <span className="mt-2 float-end">
                    <p>
                      {filteredUsers.length} {props.t("users")}
                    </p>
                  </span>
                </Col>
              </Row>

              <Accordion
                flush
                open={filtersOpen}
                toggle={id => {
                  id === filtersOpen
                    ? setFiltersOpen("")
                    : setFiltersOpen(id)
                }}
              >
                <AccordionItem>
                  <AccordionBody
                    accordionId="1"
                    className="mb-3"
                    style={{
                      border: "1px solid",
                      borderRadius: "4px",
                    }}
                  >
                    <Row className="mb-3">
                      <Col className="col-auto">
                        <span
                          className="font-size-16 text-primary"
                          style={{ fontWeight: "500" }}
                        >
                          <i className="mdi mdi-filter me-1"></i>
                          {props.t("Filters")}
                        </span>
                      </Col>
                      <Col>
                        <Button
                          color="danger"
                          outline
                          size="sm"
                          onClick={() => {
                            setGroupHostFilter()
                            setAppointmentsFilter()
                            setGroupMessagesFilter()
                            setVideoSettingsFilter()
                            setVideoSystemFilter()
                          }}
                        >
                          <i className="mdi mdi-close me-1"></i>
                          {props.t("Clear")}
                        </Button>
                      </Col>
                    </Row>
                    <Row xs={1} sm={2} md={3} xl={4}>
                      <Col className="mb-3">
                        <Select
                          placeholder={props.t("Group host")}
                          allowClear
                          style={{ width: "100%" }}
                          value={groupHostFilter}
                          onChange={v => {
                            setGroupHostFilter(v)
                          }}
                          options={[
                            {
                              value: "1",
                              label: props.t("Group host") + " " + props.t("Enabled").toLowerCase(),
                            },
                            {
                              value: "2",
                              label: props.t("Group host") + " " + props.t("Disabled").toLowerCase(),
                            },
                          ]}
                        />
                      </Col>
                      <Col className="mb-3">
                        <Select
                          placeholder={props.t("Appointments")}
                          allowClear
                          style={{ width: "100%" }}
                          value={appointmentsFilter}
                          onChange={v => {
                            setAppointmentsFilter(v)
                          }}
                          options={[
                            {
                              value: "1",
                              label: props.t("Appointments") + " " + props.t("Enabled").toLowerCase(),
                            },
                            {
                              value: "2",
                              label: props.t("Appointments") + " " + props.t("Disabled").toLowerCase(),
                            },
                          ]}
                        />
                      </Col>
                      <Col className="mb-3">
                        <Select
                          placeholder={props.t("Group messages")}
                          allowClear
                          style={{ width: "100%" }}
                          value={groupMessagesFilter}
                          onChange={v => {
                            setGroupMessagesFilter(v)
                          }}
                          options={[
                            {
                              value: "1",
                              label: props.t("Group messages") + " " + props.t("Enabled").toLowerCase(),
                            },
                            {
                              value: "2",
                              label: props.t("Group messages") + " " + props.t("Disabled").toLowerCase(),
                            },
                          ]}
                        />
                      </Col>
                      <Col className="mb-3">
                        <Select
                          placeholder={props.t("Video system")}
                          allowClear
                          style={{ width: "100%" }}
                          value={videoSystemFilter}
                          onChange={v => {
                            setVideoSystemFilter(v)
                          }}
                          options={[
                            {
                              value: "1",
                              label: props.t("Video system") + " " + props.t("Enabled").toLowerCase(),
                            },
                            {
                              value: "2",
                              label: props.t("Video system") + " " + props.t("Disabled").toLowerCase(),
                            },
                          ]}
                        />
                      </Col>
                      <Col className="mb-3">
                        <Select
                          placeholder={props.t("Video app settings")}
                          allowClear
                          style={{ width: "100%" }}
                          value={videoSettingsFilter}
                          onChange={v => {
                            setVideoSettingsFilter(v)
                          }}
                          options={[
                            {
                              value: "1",
                              label: props.t("Video app settings") + " " + props.t("Enabled").toLowerCase(),
                            },
                            {
                              value: "2",
                              label: props.t("Video app settings") + " " + props.t("Disabled").toLowerCase(),
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>

              <Collapse isOpen={selectedRowKeys.length > 0}>
                <Row className="pb-2">
                  {singleGroup &&
                    <Col className="col-auto">
                      <Button
                        color="success"
                        className="compact-button"
                        disabled={selectedRowKeys.length == 0 || loading}
                        onClick={() => {
                          linkUsers()
                        }}
                      >
                        <i className="mdi mdi-link-variant-plus me-2" />
                        {props.t("Link selected users")}
                      </Button>
                      <Button
                        color="danger"
                        className="ms-3 compact-button"
                        disabled={selectedRowKeys.length == 0 || loading}
                        onClick={() => {
                          unlinkUsers()
                        }}
                      >
                        <i className="mdi mdi-link-variant-off me-2" />
                        {props.t("Unlink selected users")}
                      </Button>
                    </Col>
                  }
                  <Col style={{ alignContent: "center" }}>
                    <span>
                      {selectedRowKeys.length +
                        " " +
                        props.t("selected users")}
                    </span>
                    <Button
                      color="danger"
                      outline
                      size="sm"
                      className="ms-2"
                      onClick={() => {
                        resetSelections()
                      }}
                    >
                      {props.t("Clear selections")}
                    </Button>
                  </Col>
                </Row>
              </Collapse>

              <div className="mt-1">
                <AntdTable
                  className="colored-header narrow-header"
                  bordered
                  size="small"
                  rowKey={"id"}
                  loading={loading}
                  columns={columns}
                  dataSource={filteredUsers}
                  //rowSelection={singleGroup ? rowSelection : null}
                  rowSelection={rowSelection}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    pageSizeOptions: defaultPageSizeOptions,
                  }}
                  tableLayout="auto"
                  scroll={{
                    x: "max-content",
                    y: tableDefaultHeight,
                  }}
                />
              </div>
            </CardBody>
          </Card>


          {/**  User add modal */}
          <Modal
            isOpen={addModal}
            toggle={() => {
              setAddModal(!addModal)
            }}
            centered
          >
            <ModalHeader>{props.t("Create a new user")}</ModalHeader>
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalBody>
                <Alert color={"info"}>
                  <span>
                    {props.t("User will be linked to currently selected group")}
                  </span>
                </Alert>
                <Alert color={"info"}>
                  <span>{props.t("UserAllowedChars")}</span>
                </Alert>
                <FormGroup>
                  <Label>{props.t("Username")}</Label>
                  <AntdForm.Item
                    validateStatus={validation.errors.username ? "error" : ""}
                    hasFeedback
                    help={validation.errors.username}
                  >
                    <AntdInput
                      allowClear
                      placeholder={"E.g. firstname.lastname"}
                      value={validation.values.username}
                      onChange={v => {
                        validation.setFieldValue("username", v.target.value)
                      }}
                    />
                  </AntdForm.Item>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setAddModal(false)
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  color="success"
                  disabled={ongoingAdd}
                  onClick={() => {
                    validation.submitForm()
                  }}
                >
                  {props.t("Add")}
                </Button>{" "}
              </ModalFooter>
            </Form>
          </Modal>

          <KeycloakUserDrawer
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            selectedRow={selectedRow}
            getAdmins={groupSearch ? fetchUsers : searchUser}
          />
        </Container>
      </div>
    </>
  )
}

KeycloakUsers.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(KeycloakUsers)
